import Marquee from "react-fast-marquee";
import { Wallet, CreditCard, Bitcoin, Coins, Landmark, DollarSign, Send } from "lucide-react";

const methods = [
  { name: "Skrill", Icon: Send, color: "#862165" },
  { name: "Neteller", Icon: CreditCard, color: "#00AC5B" },
  { name: "PayPal", Icon: Wallet, color: "#003087" },
  { name: "Crypto", Icon: Bitcoin, color: "#F7931A" },
  { name: "Payoneer", Icon: DollarSign, color: "#FF4800" },
  { name: "Perfect Money", Icon: Coins, color: "#DC0000" },
  { name: "Revolut", Icon: Landmark, color: "#0075EB" },
];

export default function PaymentMarquee() {
  return (
    <div data-testid="payment-marquee" className="w-full">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {methods.map((m) => (
          <div
            key={m.name}
            data-testid={`payment-logo-${m.name.toLowerCase().replace(" ", "-")}`}
            className="mx-6 sm:mx-10 flex items-center gap-3 py-4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
          >
            <div
              className="w-11 h-11 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${m.color}18`, color: m.color }}
            >
              <m.Icon size={22} strokeWidth={2.2} />
            </div>
            <span className="font-display font-semibold text-lg text-ink-700 whitespace-nowrap">
              {m.name}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export { methods as paymentMethods };
